import { IGameAttendancesVotes } from "./../../../";
import server from "../Server";
import withErrorCheck from "../CheckError";
import { GetGameVotesPayload } from '@grassrootly/api/gateways/game/GetGameVotes';

export const GetGameVotes = async (payload: GetGameVotesPayload): Promise<{ votes: IGameAttendancesVotes[], playerVoted: number }> => {
  
  const votes = withErrorCheck(
    await server
      .from("GameAttendanceVotes")
      .select("*, GameAttendances!inner(*)")
      .eq("GameAttendances.game_id", payload.gameId)
  );

  return {
    votes,
    playerVoted: countDistinctPlayers(votes)
  };
};

const countDistinctPlayers = (data: IGameAttendancesVotes[]) => {
  if (!data || !data.length) return 0;

  const playerIds = new Set();

  data.forEach(entry => {
    playerIds.add(entry.player_id);
  });

  return playerIds.size;
}
